// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + {"3332":"f4ac56d4b579bcb5","5285":"3ddf63f87b0ca61b"}[chunkId] + ".css";
};